import { useState, useEffect } from 'react';

const initialPluginData = {
  activeItem: null,
  show: false,
  coords: { start: {}, end: {} },
  node: null
};

function useFloatingMenuPlugin(editorReady, editorViewRef) {
  const [floatingMenuPluginState, setFloatingMenuPluginState] = useState(
    initialPluginData
  );

  const plugin =
    editorViewRef.current && editorViewRef.current.pluginViews
      ? editorViewRef.current.pluginViews.find(p => p.name === 'floating-menu-plugin')
      : {};
  useEffect(() => {
    if (editorReady) {
      const activeItem = plugin.items.find(item => item.name === plugin.open) || null;
      setFloatingMenuPluginState({
        activeItem,
        show: !!activeItem,
        coords: plugin.coords,
        node: plugin.node
      });
    }
  }, [editorReady, plugin && plugin.updatedAt]);

  return floatingMenuPluginState;
}

export default useFloatingMenuPlugin;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/floatingMenu/useFloatingMenuPlugin.js